import { graphql } from "lib/generated/app-service-gql";
import {
  ToneOfVoiceDocumentProcessingStatusSubscription,
  ToneOfVoiceDocumentProcessingStatusSubscriptionVariables,
} from "lib/generated/app-service-gql/graphql";
import { useSubscription, UseSubscriptionOptions } from "../useGraphQlClient";

// adding this so it generates the types
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _onAiChatResponse = graphql(`
  subscription toneOfVoiceDocumentProcessingStatus($processingId: String!) {
    toneOfVoiceDocumentProcessingStatus(processingId: $processingId) {
      processingId
      status
      rawValue
      label
      error
    }
  }
`);

export function useToneOfVoiceDocumentProcessingStatus(
  processingId: string,
  options: UseSubscriptionOptions<ToneOfVoiceDocumentProcessingStatusSubscription>,
) {
  return useSubscription<
    ToneOfVoiceDocumentProcessingStatusSubscription,
    ToneOfVoiceDocumentProcessingStatusSubscriptionVariables
  >(
    `subscription toneOfVoiceDocumentProcessingStatus($processingId: String!) {
      toneOfVoiceDocumentProcessingStatus(processingId: $processingId) {
        processingId
        status
        rawValue
        label
        error
      }
    }`,
    { processingId },
    { ...options },
  );
}
